<div class="container">
  <div class="row">
    <h4 class="title">{{ hotel.name }}</h4>&nbsp;
    <i class="travel-icon icon-star" aria-hidden="true" *ngFor="let Star of starsArr; let Si = index"></i>
  </div>
  <div class="row">
    <small>{{ hotel.address }}</small>
  </div>
</div>
